<div class="pension-source-container">
<div class="col-md-5 col-sm-12 source-div" 
  [ngClass]="{'margin-left-7':((sourceConfig['code']==='B') && sourceSelected 
    && sourceSelected.value !== 'B')}" *ngIf="sourceConfig['enableFlag']"
  [formGroup]="parent">
  <div class="border-div">
    <div class="logo-div">
      <!-- <img [id]="'img-'+getID(sourceConfig['sourceName'])" *ngIf="sourceConfig['iconSrcUrl'] !== ''; else otherSource" [src]="sourceConfig['iconSrcUrl']"
      [alt]="sourceConfig['sourceName']">
    <ng-template #otherSource>
      <span class="other-source" id="{{sourceName}}">{{sourceConfig['sourceName']}}</span>
    </ng-template> -->
      <span class="other-source" id="{{sourceName}}">{{(length === 1 || isDealPartnerWithoutProductCode) ? contentData.pensionPotText : sourceConfig['sourceName']}}</span>
    </div>

    <app-currency class="currency-box" [parent]="parent" [controllerData]="fundConfig" (currencyChangeEventEmitter)="currencyChangeHandler($event)"
      (currenyChildEmitter)="currenyChangeChildHandler($event)"></app-currency>
    
    <div *ngIf="sourceConfig['productCodeFlag'] && fundAmount > 0">
      <div class="separator"></div>
      <div class="infoPositioning">
      <label for="{{productCodeConfig['name']}}" class="form-label product-code" [id]="'lbl-'+productCodeConfig['label']">{{productCodeConfig['label']}}</label>
    </div>
    <div class="infotext">
      <app-tool-tip-notification (contractCodeEmitter)="contractCodeReceiver($event)"
      (GACodeEmitter)="GACodeReceiver($event)" [childId]="sourceConfig['sourceName']"  
        [tooltipName]="" [tooltipData]="sourceConfig['infoIconData']"
        (onDisplayMobileTooltipEmitter)="displayTooltipMessage()">
        </app-tool-tip-notification>

        <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
        (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>
      </div>
      <div class="code-input" [formArrayName]="'productCode'">
         
          <div class="display-inline-flex" *ngFor="let prdcode of parent.get('productCode').controls || []; let i=index">
              <app-text-input  [controlName] ="i" [sourceData]="sourceConfig" [parent]="parent.get('productCode')" [controllerData]="productCodeConfig"
              [pageName]="'yourPensionSavings'" (textChangeEventEmitter)="productCodeChangeHandler(code)"></app-text-input>
             
              <span class="icon icon-plus delete-icon" *ngIf="parent.get('productCode').controls.length > 1"  (click)="removeConractCode(i)"></span>  
          </div>
         
      </div>
      
      <button *ngIf="sourceConfig['sourceName'] == 'ReAssure'" id="btn-addNewcontract" name="addNewContractCode" class="btn add-new-code" 
       type="button" (click)="addInsertRecords()" [disabled]="parent.get('productCode').controls.length >= 10">{{productCodeConfig['addAnothercode']}}
        <i class="icon icon-plus fl-right" aria-hidden="true"></i>
      </button>
      
      <div id="productCodeError" class="col-xs-12 form-validation-error" *ngIf="minprodCodeLength.value">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p  id="noFund-error">{{productCodeConfig['errorProductCode']}}</p>
      </div>

    </div>
  </div>
  <div class="col-md-6 form-validation-error text-left" *ngIf="parent.get('fundValue').touched
                        &&
             parent.get('fundValue').errors && parent.get('fundValue').errors.emptyFund">
    <i class="icon icon-error" aria-hidden="true"></i>
    <p [id]="'fundValue-error'">
      {{productCodeConfig.validationMsg}}
    </p>
  </div>
</div>
</div>